import Grid from "@mui/material/Grid";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { StyleSheet } from "./SpotDataInDetail";
import { memo, useEffect, useState } from "react";
import { SensorOverviewProps } from "./InAndOutDataInDetail";
import { EmergencyOverview } from "../../../../../types/sensor";
import api from "../../../../api/api";
import moment from "moment";
import CountUp from "react-countup";

const styles = StyleSheet.create({
  box: {
    alignItems: "center",
    height: "28px",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  key: {
    color: "#565656",
    fontSize: "12px",
  },
  value: {
    color: "#333333",
    fontSize: "14px",
    fontWeight: "bold",
    textAlign: "end",
    lineHeight: 0.7,
  },
  subValue: {
    color: "#ABAABA",
    fontSize: "10px",
    fontWeight: "normal",
  },
});

type PieChart = { labels: Array<any>; series: Array<any> };

const EmergencyDataInDetail = memo(({ sensorId, setRssi, setBattery }: SensorOverviewProps) => {
  const [data, setData] = useState<EmergencyOverview | undefined>();
  const [pieData, setPieData] = useState<PieChart>({ labels: [], series: [] });

  const fetchData = async () => {
    const res = await api.get<EmergencyOverview>(`/v1/sensor/sos/${sensorId}/overview`);
    if (!res.ok || !res.data) return;
    setRssi && setRssi(res.data.rssi);
    setBattery && setBattery(res.data.battery);
    setData(res.data);
  };
  const fetchPieData = async () => {
    const res = await api.get<{ data: Array<any> }>(`/v1/sensor/sos/${sensorId}/summary`, {
      start_date: moment().format("YYYY-MM-DD"),
    });
    if (!res.ok || !res.data) return;
    let d: typeof pieData = { labels: [], series: [] };
    const summary: { data: Array<{ id: string; value: number }> } = res.data;
    const noData = {
      labels: [],
      series: [],
    };
    if (!summary) return setPieData(noData);
    const normal = summary.data?.find((obj) => obj.id === "정상");
    const abnormal = summary.data?.find((obj) => obj.id === "비정상");
    if (!normal || !abnormal) {
      return setPieData(noData);
    }

    setPieData({
      labels: [normal.id, abnormal.id],
      series: [normal.value, abnormal.value],
    });
  };

  useEffect(() => {
    fetchData();
    fetchPieData();
  }, []);

  const chartOptions: ApexOptions = {
    labels: pieData.labels,
    legend: {
      show: false,
    },
    colors: ["#FF8080", "#80C2FF"],
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -35,
        },
      },
    },
    noData: {
      text: "데이터 없습",
    },
  };

  return (
    <Grid container marginTop={"7px"}>
      <Grid item container flex={1} flexDirection="column">
        <Grid item container style={styles.box}>
          <span style={styles.key}>최근 비상 감지</span>
          <span style={styles.value}> {moment(data?.recent_emergency_detection).format("MM/DD hh:mm")}</span>
        </Grid>
        <Grid item container style={styles.box}>
          <span style={styles.key}>최근 비정상 신호</span>
          <span style={styles.value}>
            {moment(data?.recent_abnormal_detection).format("MM/DD hh:mm")} <br />
          </span>
        </Grid>
        <Grid item container style={styles.box}>
          <span style={styles.key}>최근 정상 신호 </span>
          <span style={styles.value}> {moment(data?.recent_normal_detection).format("dd hh:mm")}</span>
        </Grid>
      </Grid>
      <Grid item container flex={1} paddingLeft="45px">
        <Grid item container style={styles.box}>
          <span style={styles.key}>주간 누적 비상 감지</span>
          <span style={styles.value}>
            <CountUp end={data ? data?.weekly_cumulative_emergency_detection : 0} duration={1} />회
          </span>
        </Grid>
        <Grid item container style={styles.box}>
          <span style={styles.key}>최다 비상 감지 요일</span>
          <span style={styles.value}>
            {data?.most_emergency_detection_days.day} <br />
            <span style={styles.subValue}>(월 평균 {data?.most_emergency_detection_days.count}회)</span>
          </span>
        </Grid>
        <Grid item container style={styles.box}>
          <span style={styles.key}>월간 비상 감지 증감율</span>
          <span style={styles.value}>
            {data?.monthly_emergency_detection_growth_rate.rate}% <br />
            <span style={styles.subValue}>( {data?.monthly_emergency_detection_growth_rate.number})</span>
          </span>
        </Grid>
      </Grid>
      <Grid item container width={"318px"} paddingLeft="25px">
        <ReactApexChart options={chartOptions} series={pieData.series} type="pie" width={200} />
      </Grid>
    </Grid>
  );
});

export default EmergencyDataInDetail;
